import { Button } from "@mui/material";
import { ButtonStyles } from "./ButtonStyles";

export default function ReportButton({ href }: { href: string }) {
  return (
    <ButtonStyles>
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Button variant="outlined">View Report</Button>
      </a>
    </ButtonStyles>
  );
}
